// AppThemeProvider.js
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const ThemeContext = createContext();

export const useAppTheme = () => useContext(ThemeContext);

export const AppThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem("theme") || "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem("theme", mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prev) => (prev === "light" ? "dark" : "light"));
  };

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: "#1976d2",
          },
          secondary: {
            main: "#dc004e",
          },
          warning: {
            main: "#C14D41",
            primary: "#ff9800",
          },
          menu: {
            menuOpen: mode === "dark" ? "#383838" : "#E0E0E0",
          },
          background: {
            default: mode === "dark" ? "#303030" : "#ffffff",
            invert: mode === "dark" ? "#ffffff" : "#303030",
            paper: mode === "dark" ? "#1d1d1d" : "#f5f5f5",
            accent: mode === "dark" ? "#424242" : "#FAFCFE",
            land: mode === "dark" ? "#414141" : "#FAFCFE",
            landCover: mode === "dark" ? "#303030" : "#dddddd",
            searchBar: mode === "dark" ? "#505050" : "#f0f0f0",
            searchBarAccent: mode === "dark" ? "#606060" : "#e0e0e0",
            searchFormControl: mode === "dark" ? "#606060" : "#e0e0e0",
            subBox: mode === "dark" ? "#3a3a3a" : "#f5f5f5",
          },

          text: {
            primary: mode === "dark" ? "#ffffff" : "#585858",
            secondary: mode === "dark" ? "#ffffff" : "#ccc",
            invert: mode === "dark" ? "#ffffff" : "#ffffff",
            shadow: mode === "dark" ? "0 0 3px  #000, 0 0 2px #000" : "0 0 3px  #aaa, 0 0 2px #aaa",
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
